import { z } from 'zod';

import type { OpsActionableKind } from './ops-cases.js';

/**
 * Operations desks (2026-10-28). An ops user sits on one desk; a won lead
 * becomes one ops case per desk that has items, dealt round-robin within
 * that desk. Server source: apps/api/src/modules/ops-cases.
 */
export const OPS_DEPARTMENTS = ['FLIGHT', 'DMC_HOTEL', 'VISA'] as const;
export const OpsDepartmentSchema = z.enum(OPS_DEPARTMENTS);
export type OpsDepartment = z.infer<typeof OpsDepartmentSchema>;

export const OPS_DEPARTMENT_LABEL: Record<OpsDepartment, string> = {
  FLIGHT: 'Flight',
  DMC_HOTEL: 'DMC / Hotel',
  VISA: 'Visa',
};

/** Which desk books a kind of item: flights and visas have their own, the rest is ground (DMC). */
export const opsDepartmentOfKind = (kind: OpsActionableKind): OpsDepartment => {
  if (kind === 'flight') return 'FLIGHT';
  if (kind === 'visa') return 'VISA';
  return 'DMC_HOTEL';
};
